export default __webpack_public_path__ + "static/media/GeneralStaff_Background.5b878c55.svg";